import React, { useState } from "react";


import img1 from '../../assets/Ornament 1.png'
import img2 from '../../assets/Ornament 67.png'
import img3 from '../../assets/Ornament 68.png'
import jonathan from '../../assets/jonathan.jpg'
import Tom from '../../assets/Tom.jpg'
import Sarah from '../../assets/Sarah.jpg'
import marina from '../../assets/marina.jpg'
import mario from '../../assets/mario.jpg'
import anonymous from '../../assets/avatar.png'
import rachel from '../../assets/Rachel.png'


import "../../styles/Reviews.css";
const testimonials = [
  {
    id: 1,
    name: "Jonathan",
    avatar: jonathan,
    title: "Rachel has been an amazing",
    message:
      "Support through a very difficult time of my life. I always look forward to my sessions with her, particularly how she understands the situation I am in and is able to give useful advice."
  },
  {
    id: 2,
    name: "Tom",
    avatar: Tom,
    title: "Rachel is kind, compassionate and brilliant.",
    message:
      " She's helped me feel safe to open up and has made me feel heard. I've been to many therapists with little success or progress. So Rachel definitely stands out. She can really help, even with those with deep traumas we dont like to talk about. I would highly recommend her to my friends and family"
  },
  {
    id: 3,
    name: "Sarah",
    avatar: Sarah,
    title: "Rachel is absolutely amazing.",
    message:
      "She listens to what you're telling her. She asks the important questions and offers practical solutions to help you be your best self. I couldn't recommend her more"
  },
  {
    id: 4,
    name: "Marina",
    avatar: marina,
    title: "I have had a few sessions with Rachel ",
    message:
      "She is very helpful and warm. I look forward to the sessions and find she is very good at encouraging my self motivation and Family issues."
  },
  {
    id: 5,
    name: "Mario",
    avatar: mario,
    title: "Great therapy so far regarding anxiety",
    message:
      ",lots of improvements have been made. Highly Recommend Rachel. Very easy to talk to and good advice."
  },
  {
    id: 6,
    name: "Anonymous",
    avatar: anonymous,
    title: "Really lovely, easy to talk to.",
    message:
      "Validates my feelings about things and helps with strategies not just to cope but to move forward too."
  },
  {
    id: 7,
    name: "Anonymous",
    avatar: rachel,
    title: "Really lovely, easy to talk to.",
    message:
      "Validates my feelings about things and helps with strategies not just to cope but to move forward too."
  },
];


const Reviews = () => {


  const [activeIndex, setActiveIndex] = useState(0);
  const avatarsToShow = 5;
  const halfAvatars = Math.floor(avatarsToShow / 2);

  const getVisibleIndices = () => {
    let start = activeIndex - halfAvatars;
    let end = activeIndex + halfAvatars;

    if (start < 0) {
      start = 0;
      end = avatarsToShow - 1;
    } else if (end >= testimonials.length) {
      end = testimonials.length - 1;
      start = end - (avatarsToShow - 1);
    }

    return { start, end };
  };

  const { start, end } = getVisibleIndices();
  const visibleTestimonials = testimonials.slice(start, end + 1);

  // const handleNext = () => {
  //   setActiveIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  // };

  // const handlePrev = () => {
  //   setActiveIndex(
  //     (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
  //   );
  // };
  const handleNext = () => {
    setActiveIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrev = () => {
    setActiveIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleSelect = (index) => {
    setActiveIndex(index);
  };

  return (
    <div className="testimonial-carousel">

      <img src={img1} className="one" alt="" />
      <img src={img3} className="three" alt="" />
      <img src={img2} className="two" alt="" />

      <img src={img1} className="four" alt="" />

      <h2>Here is what our Clients are saying About us</h2>
      <div className="testimonial-card-wrapper">
        <div className="testimonial-card">
          <div className="arrow left-arrow" onClick={handlePrev}>
            &#8249;
          </div>
          <div className="testimonial-content">
            <h3>{testimonials[activeIndex].title}</h3>
            <p>{testimonials[activeIndex].message}</p>
          </div>
          <div className="arrow right-arrow" onClick={handleNext}>
            &#8250;
          </div>
        </div>
        <div className="testimonial-card-arrow"></div>
      </div>

      <img src={img2} className="four" alt="" />
      <img src={img3} className="five" alt="" />


      <div className="profile">
      <div className="avatars">
          {visibleTestimonials.map((testimonial, index) => {
            const globalIndex = start + index;
            return (
              <img
                key={testimonial.id}
                src={testimonial.avatar}
                alt={testimonial.name}
                className={`avatar ${globalIndex === activeIndex ? "active-avatar" : ""}`}
                onClick={() => handleSelect(globalIndex)}
              />
            );
          })}
        </div>
        <p className="profile-name">{testimonials[activeIndex].name}</p>
      </div>

    </div>
  );
};




export default Reviews;

